import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

const FormField = styled(TextField)(({ theme }) => ({
	'label + &': {
		marginTop: theme.spacing(3),
	},
	'& fieldset': {
		border: 'none'
	},
	'& .MuiInputBase-root': {
		padding: 0,
		border: "1px solid #F0F1F5",
		borderRadius: 5,
		backgroundColor: "#FFFFFF",
		transition: theme.transitions.create(['border-color', 'box-shadow']),

		'&.Mui-disabled': {
			backgroundColor: '#F0F1F5',
		},
	},
	'& .MuiInputBase-input': {
		borderRadius: 5,
		position: 'relative',
		fontSize: 16,
		width: '100%',
		border: "1px solid #F0F1F5",
		backgroundColor: "#FFFFFF",
		padding: '10px 18px 9px 10px',
		transition: theme.transitions.create([
			'border-color',
			'background-color',
			'box-shadow',
		]),
		fontFamily: [
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),

		'&.Mui-disabled': {
			backgroundColor: '#F0F1F5',
		},
			'&.no-transform::placeholder': {
  textTransform: 'none',
},
		'&::placeholder': {
			textTransform: 'capitalize',
			fontFamily: [
				'-apple-system',
				'BlinkMacSystemFont',
				'"Segoe UI"',
				'Roboto',
				'"Helvetica Neue"',
				'Arial',
				'sans-serif',
				'"Apple Color Emoji"',
				'"Segoe UI Emoji"',
				'"Segoe UI Symbol"',
			].join(','),
			fontStyle: 'normal',
		},
	},
	'& .MuiFormHelperText-root': {
		marginLeft: 0
	},
	'& .MuiInputBase-inputSizeSmall':{
		fontSize: '14px',
		height: '14px',
	}
}));

export default FormField;
